








































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AppModule } from '@/store/modules/app';
import GeoPoint from '@/models/Shared/GeoPoint';

@Component({
    name: 'GoogleMapsDialog'
})
export default class extends GiganautVueDialog {

    @Prop({required: true})
    geometry: GeoPoint;

} 
